import React from 'react';
import { Document, StyleSheet, Page, Text, View, Image, LinearGradient, Stop, Svg, Defs, Rect, Link } from '@react-pdf/renderer';
import { isEmpty } from 'lodash';
import ArrowIcon from '../assets/images/gradient-arrow-down.png';
import ErrorQrCode from '../assets/images/no-qr-code.png';
import packageJSON from '../../package.json';
import config from '../config';

const styles = StyleSheet.create({
  page: {
    flexDirection: 'row',
    backgroundColor: '#ffffff',
    padding: 10,
  },
  section: {
    flexGrow: 1,
    borderWidth: 2,
    borderStyle: 'solid',
    borderColor: '#0AD2C7',
    borderRadius: 5
  },
  header: {
    fontSize: 20,
    textAlign: 'center',
    color: "#0AD2C7",
    marginTop: 20,
    marginBottom: 20,
  },
  imageContainer: {
    flexDirection: 'row',
    alignItems: "center",
    justifyContent: "center"
  },
  image: {
    width: '15%',
    height: 'auto',
    margin: 5,
    borderWidth: 2,
    borderStyle: 'solid',
    borderColor: '#0AD2C7',
    borderRadius: 5
  },
  name: {
    fontSize: 16,
    textAlign: 'center',
    marginTop: 10,
  },
  date: {
    fontSize: 16,
    textAlign: 'center',
    marginTop: 5
  },
  red: {
    color: "#EA0F0D",
    fontSize: 15,
    textAlign: 'center',
    marginTop: 5
  },
  green: {
    color: "#43E00C",    
    fontSize: 15,
    textAlign: 'center',
    marginTop: 5
  },
  text: {
    fontSize: 12,
    textAlign: 'center',
    marginTop: 5,
    padding: 10
  },
  footer: {
    position: 'absolute',
    bottom: 30,
    left: 30,
    right: 30,
    textAlign: 'center',
    fontSize: 12,
    color: 'gray',
  },
  footerLine: {
    flexDirection: 'row',
    justifyContent: "center"
  },
  sup: {
    fontSize: 8,
  },
  gradient: {
    position: "relative",
    width: "100%",
    height: 50,
    marginTop: 60,
    marginBottom: 10,
  },
  arrow: {
    position: "absolute",
    transform: "translate(-13% -30%)",
    width: 30,
  },
  text: {
    fontSize: 12
  },
  description: {
    fontSize: 12,
    marginBottom: 5,
  },
  textContainer: {
    padding: 5
  },
  bullet: {
    marginHorizontal: 10,
    fontSize: 15,
  },
  list: {
    flexDirection: "row",
  },
  listItem: {
    flex: 1,
    marginBottom: 5,
  },
});

const CovidResultPDFV2 = (props) => {
    const { pictures, name, date, svgData, errMsg, isASymp, pos } = props.data;
    const description = isASymp ? config.description[0] : config.description[1];
    
    return (
        <Document>
          <Page size="A4" style={styles.page}>              
            <View style={styles.section}>
              <Text style={styles.header}>COVID-19 Screening Result</Text>

              {pictures.length > 0 && <View style={styles.imageContainer}>
                  <Image src={pictures[0]} style={styles.image} />
                  <Image src={pictures[1]} style={styles.image} />
                  <Image src={pictures[2]} style={styles.image} />
                  <Image src={pictures[3]} style={styles.image} />
              </View>}


              <View style={styles.gradient}>
                <View style={{...styles.arrow, left: `${pos}%`}}>
                  <Image src={ArrowIcon}/>
                </View>
                
                <Svg viewBox="0 0 300 40">
                  <Defs>
                    <LinearGradient id="myLinearGradient">
                      <Stop offset="10%" stopColor="green" />
                      <Stop offset="50%" stopColor="yellow" />
                      <Stop offset="99%" stopColor="red" />
                    </LinearGradient>
                  </Defs>
                  <Rect
                    width="300"
                    height="40"
                    fill="url('#myLinearGradient')"
                  />
                  <Text x="5" y="23" style={styles.text}>
                    Lower risk
                  </Text>
                  <Text x="240" y="23" style={styles.text}>
                    Higher risk
                  </Text>
                </Svg>
              </View>

              <View style={styles.imageContainer}>
                  {
                    isEmpty(errMsg) ? <Image src={svgData} style={styles.image} /> : <Image src={ErrorQrCode} style={styles.image} />
                  }
              </View>

              <Text style={styles.name}>{name}</Text>
              <Text style={styles.date}>{date}</Text>

              {
                    pos > 50 ? <View>
                      <Text style={styles.red}>You are at higher risk of having COVID-19.</Text>
                      <Text style={styles.red}>The eye scan detected changes that may be associated with COVID-19.</Text>
                    </View> : <View>
                      <Text style={styles.green}>You are at lower risk of having COVID-19.</Text>
                      <Text style={styles.green}>The eye scan did not detect changes that may be associated with COVID-19.</Text>
                    </View>
              }

              { isEmpty(errMsg) && <Text style={styles.text}>{errMsg}</Text>}
              
              {
                <View style={styles.textContainer}>
                  {
                        description.map((item, index) => {
                            if(item.type == "link") {
                                return <Text key={index} style={styles.description}>
                                    {
                                        item.data.map((des, i) => (
                                            des.link ? <Link src={des.link} style={styles.text}>{des.text}</Link> : des.text
                                        ))
                                    }
                                </Text>
                            }
                            if(item.type == "list") {
                              return item.data.map((listItem, k) =>{
                                if(listItem.type == "link") {
                                  return <View key={index} style={styles.list}>
                                    <Text style={styles.bullet}>•</Text>
                                    <View style={styles.listItem}>
                                      <Text style={styles.text}>
                                        {
                                          listItem.data.map((des, i) => (
                                              des.link ? <Link src={des.link} style={styles.text}>{des.text}</Link> : des.text
                                          ))
                                        }  
                                      </Text>
                                    </View>
                                  </View>
                                }
                                if(listItem.type == "text") {
                                    return <View style={styles.list}>
                                    <Text style={styles.bullet}>•</Text>
                                    <View style={styles.listItem}>
                                      <Text style={styles.text}>{listItem.data}</Text>
                                    </View>
                                  </View>
                                }
                              })
                            }
                            if(item.type == "text") {
                                return <Text style={styles.description}>{item.data}</Text>
                            }
                        })
                    }
                </View>
              }

              <View style={styles.footer}>
                <View style={styles.footerLine}>
                  <Text>{config.footer.title}</Text>
                </View>
                <View style={styles.footerLine}>
                  <Text>{config.footer.description} {packageJSON.version}</Text>
                </View>
              </View>
            </View>
          </Page>
        </Document>
      )
};

export default CovidResultPDFV2;
